import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Controlling');

export const INTERNALORDERTYPE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.InternalOrderType.Name')
    .required()
    .minLength(1)
    .maxLength(20)
    .build(),
  FieldBuilder
    .checkbox('isProjectTypeMandatory', 'Entity.InternalOrderType.IsProjectTypeMandatory')
    .build(),
];

export const INTERNALORDERTYPE_CONFIG = {
  entityName: 'InternalOrderType',
  localizationKey: 'Controlling::Entity.InternalOrderType',
  fields: INTERNALORDERTYPE_FIELDS,
  permission: 'ControllingSap.InternalOrderTypes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.SAP + MENU_NAME_SUFFIX,
};
